
import { defineComponent, ref, PropType } from 'vue'
import Icon from '@/components/base/Icon.vue'
import { IconType } from '@/enums/IconType'
import { BikeStatus } from '@/enums/bike'

interface Item {
  id: string
  name: string
}

export default defineComponent({
  name: 'SelectAndSearch',
  components: {
    Icon,
  },
  emits: ['update:keyword', 'update:category'],
  props: {
    keyword: {
      type: String,
      default: '',
    },
    category: {
      type: String as PropType<BikeStatus>,
      default: 0,
    },
    selectable: Boolean,
    placeholder: String,
    maxlength: Number,
    items: {
      type: Array as PropType<Array<Item>>,
      default: () => [],
    },
    onSearch: {
      type: Function,
      default: () => false,
    },
    onSelect: {
      type: Function,
      default: () => false,
    },
  },
  setup(props, { emit }) {
    const active = ref(false)
    const select = (e: { target: HTMLInputElement }) => {
      emit('update:category', e.target.value)
      props.onSelect()
    }
    const search = () => {
      props.onSearch()
    }
    return {
      active,
      IconType,
      search,
      select,
    }
  },
})
